import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html,
  body {
    height: 100%;
    width: 100%;
  }

  body {
    font-family: Montserrat, sans-serif;
  }

  #root {
    min-height: 100%;
    min-width: 100%;
    height: 100%;
  }

  p,
  label {
    font-family: Montserrat, sans-serif;
    line-height: 1.5em;
  }

  input, select {
    font-family: inherit;
    font-size: inherit;
  }

  .float-right {
    float: right;
  }

  a:link,
  a:visited {
    text-decoration: none;
  }

  a:hover,
  a:active {
    text-decoration: underline;
  }

`;
